import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BePadraoImportacaoCartao } from 'src/app/models/BePadraoImportacaoCartao';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-padrao-importacao-cartao',
  templateUrl: './list-padrao-importacao-cartao.component.html',
  styleUrls: ['./list-padrao-importacao-cartao.component.css']
})
export class ListPadraoImportacaoCartaoComponent implements OnInit, OnDestroy {
  public padroes: BePadraoImportacaoCartao[] = [];
  public subscription?: Subscription;
  public editandoLinha = false;

  public formatosData = ['DD/MM/AAAA', 'DD/MM/AA', 'AAAA-MM-DD', 'MM/DD/AAAA'];
  public formatosValor = ['100.50', '100,50', 'R$ 100.50', 'R$ 100,50'];
  public delimitadores = [';', ',', 'tab'];

  public colunasListaDados: ListaDadosColuna[] = [
    { campo: 'noInstituicao', rotulo: 'Instituição', tamanho: '200px', editavel: true, edicao: { tipoEditor: 'texto', validacao: { obrigatorio: true, maxLength: 100 } } },
    { campo: 'noColunaDescricao', rotulo: 'Desc.', tamanho: '60px', editavel: true, edicao: { tipoEditor: 'texto', validacao: { obrigatorio: true, maxLength: 1 } } },
    { campo: 'noColunaValor', rotulo: 'Valor', tamanho: '60px', editavel: true, edicao: { tipoEditor: 'texto', validacao: { obrigatorio: true, maxLength: 1 } } },
    { campo: 'noColunaData', rotulo: 'Data', tamanho: '60px', editavel: true, edicao: { tipoEditor: 'texto', validacao: { obrigatorio: true, maxLength: 1 } } },
    { campo: 'dsFormatoData', rotulo: 'Formato Data', tamanho: '120px', editavel: true, edicao: { tipoEditor: 'combobox', validacao: { obrigatorio: true }, opcoes: this.formatosData.map(f => ({ valor: f, rotulo: f })) } },
    { campo: 'dsFormatoValor', rotulo: 'Formato Valor', tamanho: '120px', editavel: true, edicao: { tipoEditor: 'combobox', validacao: { obrigatorio: true }, opcoes: this.formatosValor.map(f => ({ valor: f, rotulo: f })) } },
    { campo: 'dsDelimitador', rotulo: 'Delimitador', tamanho: '80px', editavel: true, edicao: { tipoEditor: 'combobox', validacao: { obrigatorio: true }, opcoes: this.delimitadores.map(d => ({ valor: d, rotulo: d === 'tab' ? 'Tab' : d })) } },
  ];

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) { }

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BePadraoImportacaoCartao[]>(
      `/api/PadraoImportacaoCartao`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.padroes = res ?? [];
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onDelete(padrao: BePadraoImportacaoCartao) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', padrao);
  }

  public onSalvarLinha(padrao: BePadraoImportacaoCartao) {
    this.unsubscribe();

    const payload: any = {
      idPadraoImportacao: padrao.idPadraoImportacao ?? null,
      noInstituicao: padrao.noInstituicao,
      noColunaDescricao: padrao.noColunaDescricao?.toUpperCase(),
      noColunaValor: padrao.noColunaValor?.toUpperCase(),
      noColunaData: padrao.noColunaData?.toUpperCase(),
      dsFormatoData: padrao.dsFormatoData,
      dsFormatoValor: padrao.dsFormatoValor,
      dsDelimitador: padrao.dsDelimitador
    };

    const requisicao = payload.idPadraoImportacao
      ? this.httpClient.put<unknown>(`/api/PadraoImportacaoCartao`, payload)
      : this.httpClient.post<BePadraoImportacaoCartao>(`/api/PadraoImportacaoCartao`, payload);

    this.subscription = requisicao.subscribe({
      next: (res: any) => {
        this.unsubscribe();
        if (!payload.idPadraoImportacao && res?.idPadraoImportacao) {
          padrao.idPadraoImportacao = res.idPadraoImportacao;
        }
        padrao.noInstituicao = payload.noInstituicao;
        this.padroes = [...this.padroes];
        this.snackBarService.exibirSucesso(payload.idPadraoImportacao ? 'Registro salvo!' : 'Registro criado!');
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', padrao: BePadraoImportacaoCartao = {} as BePadraoImportacaoCartao) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/PadraoImportacaoCartao/${padrao.idPadraoImportacao}`),
          () => this.onDeleteConfirm(padrao),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BePadraoImportacaoCartao) {
    this.padroes = this.padroes.filter(padrao => padrao.idPadraoImportacao !== res.idPadraoImportacao);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}
